"use client";

import { BUSINESS_TASKS, PRIVAT_TASKS } from "@/features/quote/shared/quote-config";
import { ChoiceCard } from "@/features/quote/ui/ChoiceCard";
import { StepHeading } from "@/features/quote/ui/StepHeading";
import { StepNav } from "@/features/quote/ui/StepNav";
import { useWizard } from "@/features/quote/ui/wizard-context";

export function TaskStep() {
  const { state, update, autoAdvance, goToStep, step, stepReady, isBusiness } = useWizard();

  if (isBusiness) {
    return (
      <section>
        <StepHeading
          title="Engangsopgave eller løbende aftale?"
          body="Vælg den type opgave I har - så ved firmaet, om det skal give jer et tilbud på en fast aftale eller en enkelt opgave."
          maxW="max-w-[26ch]"
        />
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {BUSINESS_TASKS.map((t) => (
            <ChoiceCard
              key={t.value}
              selected={state.businessTask === t.value}
              onClick={() => {
                update("businessTask", t.value);
                autoAdvance();
              }}
              icon={t.icon}
              title={t.label}
              body={t.body}
            />
          ))}
        </div>
        <StepNav
          onBack={() => goToStep(step - 1)}
          onNext={() => goToStep(step + 1)}
          nextEnabled={stepReady("task")}
          nextLabel="Næste →"
        />
      </section>
    );
  }

  return (
    <section>
      <StepHeading
        title="Hvilken slags rengøring?"
        body="Vælg om det er en løbende aftale eller en enkelt opgave."
      />
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        {PRIVAT_TASKS.map((t) => (
          <ChoiceCard
            key={t.value}
            selected={state.task === t.value}
            onClick={() => {
              update("task", t.value);
              autoAdvance();
            }}
            icon={t.icon}
            title={t.label}
            body={t.body}
          />
        ))}
      </div>
      <StepNav
        onBack={step > 1 ? () => goToStep(step - 1) : undefined}
        onNext={() => goToStep(step + 1)}
        nextEnabled={stepReady("task")}
        nextLabel="Næste →"
      />
    </section>
  );
}
